import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { SchedulingTransportActions } from "store/ducks/transports";

export function* schedulingTransportsRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      api.put,
      `/scheduling-transports/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(SchedulingTransportActions.success(data));
    notify("success", "Agendamento criado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(SchedulingTransportActions.failure(errorMessage));
  }
}
